import { Middleware } from 'redux'
import { messageActions } from './messageSlice';
import MessageEvent from './messageEvent';
import Message from "./message";
import CookieHelper from "helpers/cookie";
 
const websocketMiddleware: Middleware = store => {
  let socket;
  let tokenSend = false;
  
    const sendMessage= ((action) => {
			if(socket) { 
				let rawCookie = CookieHelper.getCookie("mmev_obj");
				if(typeof rawCookie != 'undefined' && tokenSend == false) {
					let tokenObj = JSON.parse(rawCookie);
					if (tokenObj && tokenObj.token) {
						let token = tokenObj.token;
						action.token = token;
						action.uuid = tokenObj.uuid;
						tokenSend = true;
					}
				} else if(typeof rawCookie == 'undefined' && tokenSend == true) {
					action.removeToken = true;
					tokenSend = false;
				}
				socket.send( JSON.stringify(action));
			}
	
	});
  
  
	return next => action => {
		const isConnectionEstablished = socket && store.getState().chat.isConnected;
		if (messageActions.startConnecting.match(action)) {
			if(process && process.env && process.env.REACT_APP_WS_ENDPOINT && process.env.REACT_APP_WS_ENDPOINT != "") {
				socket = new WebSocket(process.env.REACT_APP_WS_ENDPOINT); 
			}
			/*
			let rawCookie = CookieHelper.getCookie("mmev_obj");
			if(typeof rawCookie != 'undefined') {
				let tokenObj = JSON.parse(rawCookie);
				if (tokenObj && tokenObj.token) {
					let token = tokenObj.token;
					socket = new WebSocket("ws://mmv_api.dev.nl:81/ws/circufyapp?token="+token);
				}
			}
			*/
			if(socket) { 
				socket.onopen = function(event) {
					store.dispatch(messageActions.connectionEstablished());
					sendMessage(action);
				}
				
				socket.onclose = function(event) {
					store.dispatch(messageActions.stopConnecting());
					socket = null;
					//return next(action);
				}
				
	/*
				socket.on(MessageEvent.SendAllMessages, (messages: Message[]) => {
					store.dispatch(messageActions.receiveAllMessages({ messages }));
				})
	
				socket.on(MessageEvent.ReceiveMessage, (message: Message) => {
					store.dispatch(messageActions.receiveMessage({ message }));
				})
	*/
				socket.onmessage = function (event) {
					console.log(event.data);
					
				}
			}
		}
		
		if (messageActions.submitMessage.match(action) && isConnectionEstablished) {
			sendMessage(action);
		}
 
		next(action);
    }
    
}
 
export default websocketMiddleware;